interface JobCatalogLevel {
  name?: string | null
  roleName?: string | null
}
interface ReferenceContractData {
  jobTitle?: string | null
  jobCatalogLevel?: JobCatalogLevel | null
}

export const getEmployeeJobRole = (referenceContract?: ReferenceContractData | null): string => {
  const jobTitle = referenceContract?.jobTitle

  if (jobTitle) {
    return jobTitle
  }

  const jobCatalogLevel = referenceContract?.jobCatalogLevel
  const jobRoleName = jobCatalogLevel?.roleName || ''
  const jobLevelName = jobCatalogLevel?.name || ''
  if (!jobLevelName || jobLevelName === '__default__' || jobLevelName === 'null') return jobRoleName

  return `${jobRoleName}, ${jobLevelName}`
}
